/* src/app/account/digital-wallet/dw-rewardship/dw-rewardship-advanced-filter-chips/dw-rewardship-advanced-filter-chips.component.scss */
.chips {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 0.5rem 1rem;
}
:host(.dw-rewardship-advanced-filter-chips) {
  width: 100%;
  height: auto;
}
/*# sourceMappingURL=dw-rewardship-advanced-filter-chips.component.css.map */
